import { memo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import NavBarLinkItem from 'components/navbar-link/NavBarLinkItem';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { useAppInfo } from 'context';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default memo(function DebtMenuItem({ item }) {
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const [, dispatch] = useAppInfo();
  const { t } = useTranslation();
  const { pathname, search } = useLocation();

  const url = pathname?.includes('admin/arrears')
    ? `/dictionary/debtnum${search}`
    : '/dictionary/debtnum';

  const { data, refetch } = useQuery({
    queryKey: ['/dictionary/debtnum', url],
    queryFn: async function () {
      const response = await axiosPrivate.get(url);
      return response.data.data;
    },
    enabled: !hasError,
    onError: () => {
      setHasError(true);
    },
    retry: false,
  });

  useEffect(() => {
    dispatch({ type: 'setRefetchDebtCount', payload: refetch });
  }, [refetch, dispatch]);

  return (
    <NavBarLinkItem
      linkData={{
        path: item.linkData.path,
        title: (
          <div className='flex items-center justify-between w-full'>
            {t(item.linkData.title)}
            <span className='border px-1 rounded-full border-red-500 bg-red-500 text-white text-[10px] leading-[15px] !h-fit'>
              {data ?? 0}
            </span>
          </div>
        ),
      }}
      iconName={item.iconName}
      delay={item.ind * 0.1}
    />
  );
});
